import { HttpClient } from "@angular/common/http";
import { UrlBuilder } from "../models/frontend_entities/UrlBuilder";
import Constants from "../Constants";
import { Injectable } from "@angular/core";
import { CompoApp } from "./CompoApp";
import {
  UserRightsFunctionToUserPrivilegesDTO
} from "../models/rights/user-rights-function/UserRightsFunctionToUserPrivilegesDTO";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";

@Injectable()
export class UserPrivilegeRequestService {


  //region constructor
  constructor(public app: CompoApp, public http: HttpClient) {
  }

  //endregion

  //region USER FUNCTION MAPPING
  addUserPrivilegesToUserRightsFunctionRx(userPrivileges: UserRightsFunctionToUserPrivilegesDTO): Observable<boolean> {
    const url = new UrlBuilder(Constants.URLS.userPrivilege.addUserPrivilegesToUserRightsFunction)
      .build();

    return this.http.post<boolean>(url, userPrivileges).pipe(take(1));
  }

  removeUserPrivilegesFromUserRightsFunctionRx(userPrivileges: UserRightsFunctionToUserPrivilegesDTO): Observable<boolean> {
    const url = new UrlBuilder(Constants.URLS.userPrivilege.removeUserPrivilegesFromUserRightsFunction)
      .build();

    return this.http.post<boolean>(url, userPrivileges).pipe(take(1));
  }

  //endregion
}
